module.exports = __webpack_public_path__ + "img/c04_unittechasabarachampion_Normal_ua.8564ddcf.webp";